export default __webpack_public_path__ + "static/media/vadim-lungu.537fe582.png";